import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import { Card, CardContent } from './ui/card';
import { CheckCircle, XCircle, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const GoogleDriveCallback = () => {
  const { API } = useContext(AuthContext);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Construir API URL manualmente en caso de que el contexto no esté disponible
        const apiUrl = API || `${window.location.origin}/api`;
        console.log('API URL:', apiUrl);
        // Get authorization code from URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (error) {
          console.error('Google Drive error:', error);
          toast.error('Autorización de Google Drive cancelada');
          alert('ERROR: Autorización de Google Drive cancelada - ' + error);
          // Redirect back to archivos compartidos after a delay
          setTimeout(() => {
            window.location.href = '/app/archivos-compartidos';
          }, 5000);
          return;
        }

        if (!code) {
          console.error('No authorization code found');
          toast.error('Código de autorización no encontrado');
          alert('ERROR: Código de autorización no encontrado en la URL');
          setTimeout(() => {
            window.location.href = '/app/archivos-compartidos';
          }, 5000);
          return;
        }

        console.log('Sending code to backend:', code.substring(0, 20) + '...');

        // Send code to backend
        const response = await fetch(`${apiUrl}/google-drive/auth-callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({ code })
        });

        console.log('Backend response status:', response.status);

        if (response.ok) {
          const data = await response.json();
          console.log('Success:', data);
          toast.success('Google Drive conectado exitosamente!');
          alert('✅ Google Drive conectado exitosamente!');
          // Redirect back to archivos compartidos
          setTimeout(() => {
            window.location.href = '/app/archivos-compartidos';
          }, 2000);
        } else {
          let errorMessage = 'Error desconocido al conectar Google Drive';
          try {
            const errorData = await response.json();
            console.error('Backend error:', errorData);
            errorMessage = errorData.detail || JSON.stringify(errorData);
          } catch (parseError) {
            console.error('Could not parse error response:', parseError);
            errorMessage = `Error HTTP ${response.status}: ${response.statusText}`;
          }
          
          toast.error(errorMessage);
          alert('ERROR AL CONECTAR GOOGLE DRIVE:\n\n' + errorMessage + '\n\nCódigo HTTP: ' + response.status);
          setTimeout(() => {
            window.location.href = '/app/archivos-compartidos';
          }, 10000);
        }

      } catch (error) {
        console.error('Error in Google Drive callback:', error);
        toast.error('Error de conexión al procesar callback');
        
        // Construir mensaje de error seguro
        let errorMsg = 'ERROR DESCONOCIDO';
        if (error && error.message) {
          errorMsg = String(error.message);
        } else if (error) {
          errorMsg = 'Error sin mensaje: ' + typeof error;
        }
        
        alert('ERROR CRITICO:\n\n' + errorMsg + '\n\nPor favor toma captura.');
        
        setTimeout(() => {
          window.location.href = '/app/archivos-compartidos';
        }, 15000);
      }
    };

    handleCallback();
  }, [API]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <RefreshCw className="h-16 w-16 text-blue-600 mx-auto mb-4 animate-spin" />
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Conectando Google Drive
          </h2>
          <p className="text-gray-600 mb-4">
            Procesando autorización...
          </p>
          <div className="text-sm text-gray-500">
            Serás redirigido automáticamente
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GoogleDriveCallback;